
import { cssMixin } from "../styledMixins";
import { css } from "styled-components";

export const inputHighlighting = cssMixin(({ theme }) => css`
  &:focus-within {
    border-color: ${theme.palette.input.borderAlt};
    box-shadow: 0 0 6px ${theme.palette.input.borderAlt};
  }

  &.has-error {
    border-color: ${theme.palette.input.error};
    border-color:  ${theme.palette.input.error};
    box-shadow: 0 0 6px ${theme.palette.input.error};
  }

  &.valid:not(.has-error) {
    border-color: ${theme.palette.input.valid};
  }
`);